import React from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";

import TemplateIcon from "../../../components/uiElements/icons/onboardingIcons/TemplateIcon";

const Header = props => {
  return (
    <>
      <div className="p-3 m-0 drawer-heading">
        {props.onArrowClick &&
        (props.viewMode === 3 || props.viewMode === 2) ? (
          <TemplateIcon
            type="leftArrow"
            className="ml-n2 mr-3"
            onClick={() => {
              props.onArrowClick();
            }}
          />
        ) : (
          ""
        )}
        <span>{props.title}</span>
        <button
          onClick={() => props.onClick()}
          type="button"
          className="close float-right"
          style={
            props.viewMode == 3 || props.viewMode == 2
              ? {
                  color: "white",
                  fontSize: "17px",
                  paddingTop: "12px",
                }
              : {
                  color: "white",
                }
          }
        >
          {props.viewMode == 3 || props.viewMode == 2 ? (
            <span aria-hidden="true">Save</span>
          ) : (
            <span aria-hidden="true">&times;</span>
          )}
        </button>
      </div>
    </>
  );
};

const mapStoreToProps = ({ dashboard }) => ({
  viewMode: dashboard?.templates?.viewMode,
});

export default withRouter(connect(mapStoreToProps, null)(Header));
